// extracted by mini-css-extract-plugin
export default {"modal":"ModalConfirmation_modal__JeJST","modalCtaStyle":"ModalConfirmation_modalCtaStyle__JSVqW","button":"ModalConfirmation_button__LEYXq","icon":"ModalConfirmation_icon__-YIAy"};